export type VideoItem = {
  id: string;
  title: string;
  category: string;
  durationMinutes: number;
  resolution: string;
  uploadDate: string;
  views: number;
  cover: string;
  description: string;
  tags: string[];
};

export const videoCategories = [
  "全部",
  "剧情",
  "情侣",
  "唯美",
  "狂欢",
  "欧美",
  "日韩",
  "独立制片",
];

const cover1 =
  "https://readdy.ai/api/search-image?query=Moody%20corridor%20with%20deep%20wine%20red%20neon%20light%20strips%20along%20the%20walls%2C%20dark%20warm%20shadows%2C%20cinematic%20film%20still%2C%20atmospheric%20haze%2C%20no%20people%2C%20elegant%20minimal%20composition%2C%20high%20detail&width=640&height=360&seq=adult-video-cover-01&orientation=landscape";
const cover2 =
  "https://readdy.ai/api/search-image?query=Candlelit%20interior%20with%20burgundy%20velvet%20armchair%20and%20amber%20glass%20reflections%2C%20cinematic%20still%20life%2C%20warm%20dark%20tones%2C%20editorial%20film%20still%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=640&height=360&seq=adult-video-cover-02&orientation=landscape";
const cover3 =
  "https://readdy.ai/api/search-image?query=Rain%20covered%20window%20at%20night%20with%20warm%20amber%20street%20bokeh%20and%20dark%20burgundy%20reflections%2C%20cinematic%20mood%2C%20artistic%20film%20still%2C%20soft%20focus%2C%20high%20detail&width=640&height=360&seq=adult-video-cover-03&orientation=landscape";
const cover4 =
  "https://readdy.ai/api/search-image?query=Vintage%20microphone%20under%20a%20single%20amber%20spotlight%20in%20a%20dim%20jazz%20lounge%2C%20dark%20wine%20background%2C%20cinematic%20atmosphere%2C%20smoke%20haze%2C%20high%20detail&width=640&height=360&seq=adult-video-cover-04&orientation=landscape";
const cover5 =
  "https://readdy.ai/api/search-image?query=Flowing%20deep%20red%20silk%20fabric%20suspended%20in%20darkness%20with%20warm%20amber%20edge%20lighting%2C%20abstract%20cinematic%20texture%2C%20artistic%20composition%2C%20high%20detail&width=640&height=360&seq=adult-video-cover-05&orientation=landscape";
const cover6 =
  "https://readdy.ai/api/search-image?query=Sheer%20curtains%20moving%20in%20warm%20sunset%20light%20inside%20a%20dark%20bedroom%20with%20burgundy%20linen%2C%20moody%20editorial%20interior%20photography%2C%20cinematic%20shadows%2C%20high%20detail&width=640&height=360&seq=adult-video-cover-06&orientation=landscape";
const cover7 =
  "https://readdy.ai/api/search-image?query=Old%20film%20projector%20casting%20a%20warm%20beam%20through%20dusty%20air%20in%20a%20dark%20room%2C%20cinematic%20mood%2C%20amber%20highlights%2C%20retro%20film%20still%2C%20high%20detail&width=640&height=360&seq=adult-video-cover-07&orientation=landscape";
const cover8 =
  "https://readdy.ai/api/search-image?query=Neon%20lit%20city%20street%20at%20midnight%20reflecting%20on%20wet%20asphalt%2C%20deep%20burgundy%20and%20amber%20tones%2C%20cinematic%20wide%20shot%2C%20no%20people%2C%20high%20detail&width=640&height=360&seq=adult-video-cover-08&orientation=landscape";
const cover9 =
  "https://readdy.ai/api/search-image?query=Dark%20dance%20studio%20with%20a%20mirror%20wall%20and%20a%20single%20warm%20overhead%20lamp%2C%20burgundy%20floor%2C%20cinematic%20empty%20room%2C%20soft%20haze%2C%20high%20detail&width=640&height=360&seq=adult-video-cover-09&orientation=landscape";

export const videos: VideoItem[] = [
  {
    id: "v1",
    title: "霓虹夜色",
    category: "剧情",
    durationMinutes: 18,
    resolution: "1080P",
    uploadDate: "2026-09-28",
    views: 128400,
    cover: cover1,
    description:
      "深夜的城市光影交错，一条没有尽头的走廊，两个人隔着玻璃交换了一个眼神。全片以克制的镜头语言讲述相遇与告别，配乐采用低音萨克斯与雨声采样，适合戴上耳机安静看完。",
    tags: ["夜店", "都市", "短片"],
  },
  {
    id: "v2",
    title: "红丝绒房间",
    category: "情侣",
    durationMinutes: 24,
    resolution: "4K",
    uploadDate: "2026-09-21",
    views: 96300,
    cover: cover2,
    description:
      "一间被红丝绒包裹的房间，烛火、旧唱片和一杯没有喝完的酒。故事从一句迟到的道歉开始，在缓慢推进的长镜头里，把两个人的沉默拍得比台词更多。",
    tags: ["室内", "慢节奏", "氛围"],
  },
  {
    id: "v3",
    title: "雨夜私语",
    category: "唯美",
    durationMinutes: 15,
    resolution: "1080P",
    uploadDate: "2026-09-15",
    views: 74500,
    cover: cover3,
    description:
      "雨声是这部短片的第三位主角。镜头贴着窗玻璃移动，把城市灯火拆成一块块暖色的光斑。全片几乎没有对白，适合深夜一个人放空的时候看。",
    tags: ["雨夜", "极简", "治愈"],
  },
  {
    id: "v4",
    title: "午夜爵士",
    category: "欧美",
    durationMinutes: 32,
    resolution: "4K",
    uploadDate: "2026-09-02",
    views: 153200,
    cover: cover4,
    description:
      "一间开到凌晨三点的爵士酒吧，舞台上的麦克风始终没有人使用。导演用三段现场演奏串联起整部作品，暖橙色灯光下的一切都显得慢半拍。",
    tags: ["爵士", "酒吧", "现场"],
  },
  {
    id: "v5",
    title: "镜中之舞",
    category: "唯美",
    durationMinutes: 21,
    resolution: "1080P",
    uploadDate: "2026-08-27",
    views: 52100,
    cover: cover9,
    description:
      "空荡的舞蹈教室，镜子里只剩下一个人的影子。以身体线条和光影关系为主题的实验短片，画面干净、节奏舒缓，适合喜欢视觉系作品的朋友。",
    tags: ["舞蹈", "实验", "光影"],
  },
  {
    id: "v6",
    title: "夏日海岸",
    category: "情侣",
    durationMinutes: 27,
    resolution: "4K",
    uploadDate: "2026-08-19",
    views: 210800,
    cover: cover6,
    description:
      "盛夏、纱帘、午后三点钟的斜光。一部关于假期最后一天的温柔作品，色调偏暖，几乎没有激烈的情节，却把那种舍不得结束的情绪拍得很准。",
    tags: ["夏日", "度假", "温柔"],
  },
  {
    id: "v7",
    title: "旧放映厅",
    category: "独立制片",
    durationMinutes: 41,
    resolution: "720P",
    uploadDate: "2026-08-08",
    views: 31800,
    cover: cover7,
    description:
      "独立团队用十六毫米胶片拍摄的实验作品，讲述一家即将关门的老放映厅和它最后一位观众。颗粒感和噪点被完整保留，是一次对旧媒介的温柔告别。",
    tags: ["胶片", "怀旧", "独立"],
  },
  {
    id: "v8",
    title: "城市夜行",
    category: "日韩",
    durationMinutes: 19,
    resolution: "1080P",
    uploadDate: "2026-07-30",
    views: 88900,
    cover: cover8,
    description:
      "雨后的柏油路反着霓虹，摩托车驶过整座城市。作品以第一视角拍摄，几乎没有剪辑断点，把夜行的自由感和一点点孤独同时交到观众手上。",
    tags: ["城市", "夜行", "第一视角"],
  },
  {
    id: "v9",
    title: "慢速华尔兹",
    category: "剧情",
    durationMinutes: 36,
    resolution: "4K",
    uploadDate: "2026-07-21",
    views: 66400,
    cover: cover5,
    description:
      "用一支放慢三倍的华尔兹串起三段不同年代的故事。红色绸缎在画面里反复出现，成为时间唯一的线索。适合喜欢叙事结构的朋友反复观看。",
    tags: ["叙事", "复古", "长镜头"],
  },
];

export const featuredVideos = videos.slice(0, 4);

export const videoSortOptions = ["默认推荐", "最新上传", "最多播放"];